module.exports = __webpack_public_path__ + "media/images/brands/kirkby-tyres-assist/favicon-3b697d449ad79a5c1ec48a513807a7ce.png";